import type { CloudGraphCaseEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_CASE_ENTITY_ATI: CloudGraphCaseEntityAti[] = [
	'ati:cloud:graph:case',
];
